import axios from "axios";
import ConstantList from "../appConfig";
const API_PATH = ConstantList.API_EN_POINT + "/permission";

export const pagingPermission = (searchObject) => axios.post(API_PATH + "/search-by-page", searchObject);

export const getPermissionById = (id) => axios.get(API_PATH + "/get-by-id/" + id);

export const saveOrUpdate = permission => axios.post(API_PATH + '/save-or-update', permission);

export const deletePermission = id => axios.delete(API_PATH + '/mark-delete/' + id);

export const getAllPermission = () => axios.get(API_PATH + "/get-all")